/**
 * Document Ready
 */
$(document).ready(function () {

    'use strict';

    var debug = false;

    // 成员索引 (global)
    var memberIndex = 0;

    // 舱位索引 (global)
    var combineIndex = 0;

    // 每个仓位最大成员数
    var MAX_MEMBERS = 4;

    var deleteMember = function(btn)
    {
        if (confirm('确认删除?')) {
            $(btn).parent().parent().remove();
        }
    };


    var clog = function (b) {
        if (debug) {
            console.log("[CB]" + b);
        }
    };

    /**
     * Define the validation rules
     */
    var validationRequestForm = function () {
        clog('validationRequestForm called.');

        var fnValidator = {
            row: ".col-md-8",
            validators : {
                notEmpty : {
                    message: '请输入参团人员的名字'
                }
            }
        };

        var lnValidator = {
            row: ".col-md-8",
            validators : {
                notEmpty : {
                    message: '请输入参团人员的姓'
                }
            }
        };

        var naValidator = {
            row: '.col-md-8',
            validators : {
                notEmpty : {
                    message: '请输入参团人员的国籍'
                }
            }
        };

        var saValidator = {
            row: '.col-md-8',
            validators : {
                message: '请选择参团人性别'
            }
        };

        var biValidator = {
            row: '.col-md-8',
            validators : {
                notEmpty : {
                    message: '请输入生日'
                },
                callback : {
                    message: '日期格式不正确',
                    callback: function (value, validator, $field)
                    {
                        return moment(value, 'YYYY.MM.DD', true).isValid();
                    }
                }
            }
        };

        var pnValidator = {
            row: '.col-md-8',
            validators: {
                notEmpty: {
                    message: '请输入护照号码'
                }
            }
        };

        var pcpValidator = {
            row : '.col-md-8',
            validators : {
                notEmpty : {
                    message: '请输入护照签发地'
                }
            }
        };


        var pcdValidator = {
            row : '.col-md-8',
            validators : {
                notEmpty : {
                    message: '请输入护照签发日期'
                },
                callback : {
                    message: '日期格式不正确',
                    callback: function (value, validator, $field)
                    {
                        return moment(value, 'YYYY.MM.DD', true).isValid();
                    }
                }
            }
        };


        var pvuValidator = {
            row : '.col-md-8',
            validators : {
                notEmpty : {
                    message: '请输入护照有效期截止日期'
                },
                callback : {
                    message: '日期格式不正确',
                    callback: function (value, validator, $field)
                    {
                        return moment(value, 'YYYY.MM.DD', true).isValid();
                    }
                }
            }
        };

        // Attach validator to element
        var toRename = [
            ['member_firstname', fnValidator],
            ['member_lastname', lnValidator],
            ['member_nation',   naValidator],
            ['member_salutation', saValidator],
            ['member_birthday', biValidator],
            ['member_passport-number', pnValidator],
            ['member_passport-confirm-place', pcpValidator],
            ['member_passport-confirm-datum', pcdValidator],
            ['member_passport-valid-until', pvuValidator]
        ];

        /**
         * Add a new member block in current cabin block
         * @param button The button element (Not jquery obj)
         */
        var addMemberEvent = function(button){
            clog('addMemberEvent() called');
            clog('memberIndex = ' + memberIndex);

            var combList = $(button).parent();
            var container = combList.find('.memberBlockContainer');

            if (container.children().length >= MAX_MEMBERS) {
                alert("仓位最多容纳" + MAX_MEMBERS + "人。无法添加。");
                return false;
            }
            // Load mailTemplate and parse to jquery object
            var tpl = $($('#memberBlockTpl').val());
            var clone = tpl.clone();
            clone.removeClass('hide')
                .removeAttr('id')
                .css('display', 'block')
                .attr('data-memberIndex', memberIndex)   // Add memberIndex
                .attr('data-combineIndex', $(button).val()) // Add combine Index
                .attr('class', 'memberRow');
            // Add to DOM
            clone.appendTo(container);
            memberIndex++;
            addMemberVars(clone, toRename, memberIndex, $(button).val());
        };


        /**
         * rename the var name and add rule
         *
         * @param obj
         * @param originalNames The original val names list in array.
         * @param mIndex
         * @param cIndex
         * @returns {*}
         */
        var addMemberVars = function(obj,  originalNames, mIndex, cIndex) {
            clog('addMemberVars() called.');
            for (var i=0; i < originalNames.length; i++) {
                var originalName = originalNames[i][0];
                var validator = originalNames[i][1];

                var newName = originalName + '[' + cIndex + '][]';

                var elem = obj.find('[name="' + originalName + '"]');
                if (elem) {
                    clog('change the new name = ' + newName);
                    elem.attr('name', newName).end();
                } else {
                    alert(obj.attr('找不到 ' + originalName ));
                }
                // attach a class name
                elem.addClass(originalName + '_group');

                // Pass the validator rules to new fields as third parameter
                $('#sendRequestFormular')
                    .formValidation('addField', newName, validator)


            }
            return obj;
        };

        // remove the rule
        var removeMemberVars = function (originalNames, row) {
            var mIndex = row.attr('data-book-index');
            // Remove all rules on this object
            for (var i=0; i < originalNames.length; i++) {
                var newName = originalNames[i] + '_' + mIndex;
                $('#sendRequestFormular')
                    .formValidation('removeField', row.find('[name="' + newName + '"]'))
            }
            row.remove();
        };

        // Add validatio rules for contact
        // http://formvalidation.io/examples/adding-dynamic-field/
        $('#sendRequestFormular').formValidation(
            {
                framework: 'bootstrap',
                icon : {
                    valid: 'glyphicon glyphicon-ok',
                    invalid: 'glyphicon glyphicon-remove',
                    validating: 'glyphicon glyphicon-refresh'
                },
                fields: {
                    'contact_lastname' : {
                        row : '.col-md-8',
                        validators : {
                            notEmpty : {
                                message: '请输入联系人的姓'
                            }
                        }
                    },
                    'contact_firstname' : {
                        row : '.col-md-8',
                        validators : {
                            notEmpty : {
                                message: '请输入联系人的名'
                            }
                        }
                    },
                    'contact_email' : {
                        row : '.col-md-8',
                        validators : {
                            notEmpty : {
                                message: '请输入联系人的邮箱地址'
                            },
                            emailAddress: {
                                message: '请输入有效的Email地址'
                            }
                        }
                    },
                    'contact_mobilePhone' : {
                        row : '.col-md-8',
                        validators : {
                            notEmpty : {
                                message: '请输入联系人的手机'
                            }
                        }

                    },
                    /*
                    'emerg_lastname' : {
                        row : '.col-md-8',
                        validators : {
                            notEmpty : {
                                message: '请输入紧急联系人的姓'
                            }
                        }
                    },
                    'emerg_firstname' : {
                        row : '.col-md-8',
                        validators : {
                            notEmpty : {
                                message: '请输入紧急联系人的名'
                            }
                        }
                    },
                    'emerg_phone' : {
                        row : '.col-md-8',
                        validators : {
                            notEmpty : {
                                message: '请输入紧急联系人的电话'
                            }
                        }
                    },
                    */

                    'member_mind' : {
                        row : '.col-md-8',
                        validators : {
                            callback : {
                                message : '至少需要一名乘员',
                                callback : function (value, validator, $field) {
                                    alert(value);
                                    var count = $('#sendRequestFormular').find('[name="member_lastname"]').length;
                                    return (count>1) ? true : false;
                                }
                            }
                        }
                    }
                }
            }
        ) // formvalidation end

        // Define Add click event on add combiner button
            .on('click', '#plusCombineBtn', function () {
                clog('define the click event on plusCombineBtn.');
                combineIndex++;
                var container = $('#combineContainer');
                var tpl = $($('#combinBlockTpl').val());
                var clone = tpl.clone();
                // 添加新的乘员按钮
                var button = clone.find('.combineSelectButton');
                // Add index as val value on the button
                button.val(combineIndex);
                clog('Set button val = ' + button.val());
                $(button).on('click', button, function () {
                    addMemberEvent(this);
                });

                clone.removeAttr('id')
                    .css('display', 'block')
                    .appendTo(container);

            })


            // Remove button click handler
            .on('click', '.removeMemberButton', function() {
                if ($('input.member_lastname_group').length <= 1) {
                    alert("无法删除。至少需要有一位乘员。");
                    return;
                }

                if (confirm('确定删除?')) {
                    var row = $(this).parent().parent();
                    var toRemove = [];
                    for (var i=0; i < toRename.length; i++) {
                        toRemove[i] = toRename[i][0];
                    }
                    removeMemberVars(toRemove, row);
                }
            })
        ;
    };


    /**
     * Show the cabineIntroduct in overlay.
     *
     */
    var cabineIntroduce = function () {
        $('div.pop-overlay').css('display', 'block').css('opacity', '0.8');
        $.get('/index.php?controller=cruises&action=cabine', function (data) {
            $.popup({
                title       : '仓位介绍',
                content     : data,
                html: true,
                autoclose   : false,
                closeOverlay: true,
                closeEsc: true,
                buttons     : false,
                timeout     : 5000
            });

        });
    };

    var init = function () {
        clog("init() called.");
        // 图片平移效果
        //$('.parallax-window').parallax({}); /* Parallax modal*/
        $('#cobinMaxMember').html(MAX_MEMBERS);
        // Validation
        clog('bind validation.');
        validationRequestForm();
        // trigger the click event to add first cabin and first member form
        $('#plusCombineBtn').trigger('click');
        if ($('.combineSelectButton').length > 0) {
            $($('.combineSelectButton')[0]).trigger('click');
        }


    };


    init();
});



// WEBPACK FOOTER //
// ./resources/assets/js/cruiseBooking.js